import { StatusDaAtividade } from './enum';

export class Atividade {
  id: number;
  idCliente: number;
  dtPendente: Date;
  usuarioPendente: number;
  nomeUsuarioPendente: string;
  atividadeARealizar: string;
  status: StatusDaAtividade;
  statusDescricao: string;
  atividadeRealizada: string;
  dtConcluido?: Date;
  usuarioConcluiu?: number;
  nomeUsuarioConcluiu: string;
}
